import React, { useState, useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen";
import { useAuth } from "@/contexts/AuthContext";
import { useCompany } from "@/contexts/CompanyContext";

export default function ProtectRoute({ children, pageName }) {
    const { isAuthenticated, isLoading: isAuthLoading, mustChangePassword } = useAuth();
    const { userRole, isAdmin, canUserAccessPage, isLoading: isRoleLoading, userCompanies, userCompaniesLoaded } = useCompany();

    // Safety timeout: force exit loading after 8s to prevent infinite spinner
    const [loadingTimedOut, setLoadingTimedOut] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setLoadingTimedOut(true), 8000);
        return () => clearTimeout(timer);
    }, []);

    const isStillLoading = isAuthLoading;
    const isWaitingForRole = (isRoleLoading || (userCompanies?.length > 0 && userRole === undefined) || !userCompaniesLoaded) && !loadingTimedOut;

    if (isStillLoading || isWaitingForRole) {
        return <LoadingScreen />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (mustChangePassword) {
        return <Navigate to="/change-password" replace />;
    }

    if (pageName && !canUserAccessPage(pageName)) {
        return <Navigate to="/Dashboard" replace />;
    }

    return children;
}
